import styled from 'styled-components';
import { Icon } from '@/icons';
import { SECTIONS } from '../meta';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 80px 24px;
  color: ${({ theme }) => theme.color.textMuted};
`;

const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.color.textPrimary};
`;

export function CouncilComingSoon({ sectionId }: { sectionId: string }) {
  const label = SECTIONS.find((s) => s.id === sectionId)?.label ?? 'This section';
  return (
    <Wrap>
      <Icon name="hourglass" size={32} />
      <Title>{label}: coming soon</Title>
      <p>This part of the console isn&apos;t built yet.</p>
    </Wrap>
  );
}
